// src/router/index.ts
import { createRouter, createWebHistory } from 'vue-router'
import { APP_CONFIG } from '@/config'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue'),
    meta: { requiresAuth: false, guestOnly: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/RegisterView.vue'),
    meta: { 
      requiresAuth: false, 
      guestOnly: true,
      requiresRegistrationEnabled: true
    }
  },
  {
    path: '/recovery',
    name: 'Recovery',
    component: () => import('@/views/RecoveryView.vue'),
    meta: { 
      requiresAuth: false, 
      guestOnly: true,
      requiresRegistrationEnabled: true
    }
  },
  {
    path: '/verify-email',
    name: 'VerifyEmail',
    component: () => import('@/views/EmailVerificationView.vue'),
    meta: { 
      requiresAuth: false,
      requiresRegistrationEnabled: true
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: { requiresAuth: true, requiresVerification: true }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: { requiresAuth: true, requiresVerification: true }
  },
  {
    path: '/trash',
    name: 'Trash',
    component: () => import('@/views/TrashView.vue'),
    meta: { requiresAuth: true, requiresVerification: true }
  },

  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/SettingsView.vue'),
    meta: { requiresAuth: true, requiresVerification: true }
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('@/views/UsersView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/system-settings',
    name: 'SystemSettings',
    component: () => import('@/views/SystemSettingsView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  // ✅ ДОБАВЛЕНО: Маршрут для публичной загрузки файлов
  {
    path: '/public_upload/:link',
    name: 'PublicUpload',
    component: () => import('@/views/PublicUploadView.vue'),
    meta: { requiresAuth: false, public: true }
  },
  {
    path: '/public-links',
    name: 'PublicLinks',
    component: () => import('@/views/PublicLinksView.vue'),
    meta: { requiresAuth: true, requiresVerification: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('authToken')
  const isEmailVerified = localStorage.getItem('isEmailVerified') === 'true'
  
  // ✅ Пропускаем проверку для публичных маршрутов
  if (to.meta.public) {
    next()
    return
  }
  
  if (!APP_CONFIG.PUBLIC_REGISTRATION_ENABLE) {
    const registrationRoutes = ['/register', '/recovery', '/verify-email']
    if (registrationRoutes.includes(to.path)) {
      next('/login?registration_disabled=true')
      return
    }
  }
  
  if (to.meta.requiresAuth && !token) {
    next('/login')
    return
  }
  
  if (to.meta.guestOnly && token) {
    next('/dashboard')
    return
  }
  
  if (to.meta.requiresVerification && !isEmailVerified && to.path !== '/verify-email') {
    next('/verify-email')
    return
  }
  
  if (to.meta.requiresRegistrationEnabled && !APP_CONFIG.PUBLIC_REGISTRATION_ENABLE) {
    next('/login')
    return
  }
  
  next()
})

export default router